import { ActionIcon, Group, GroupProps, Indicator } from "@mantine/core"
import { IconFilterOff, IconFilter } from "@tabler/icons-react"
import { useBreakpoints } from "../../../utils/use-breakpoints"

interface HideableFilterGroupProps extends GroupProps, React.PropsWithChildren {
  visible: boolean
}

export function HideableFilterGroup({
  visible,
  children,
  ...props
}: HideableFilterGroupProps) {
  const { xs } = useBreakpoints()
  return (
    <Group
      w={xs ? "100%" : undefined}
      display={visible ? undefined : "none"}
      {...props}
    >
      {children}
    </Group>
  )
}

interface FilterVisibilityButtonProps {
  activeFilters?: number
  visible: boolean
  onChange: (value: boolean) => void
}
function FilterVisibilityButton({
  onChange,
  visible,
  activeFilters,
}: FilterVisibilityButtonProps) {
  return visible ? (
    <ActionIcon variant="subtle" onClick={() => onChange(visible)}>
      <IconFilterOff />
    </ActionIcon>
  ) : (
    <Indicator
      radius={"md"}
      zIndex={1}
      withBorder
      disabled={!activeFilters}
      label={activeFilters}
      size={20}
    >
      <ActionIcon
        variant={activeFilters ? "filled" : "subtle"}
        onClick={() => onChange(visible)}
      >
        <IconFilter />
      </ActionIcon>
    </Indicator>
  )
}

HideableFilterGroup.Button = FilterVisibilityButton
